module.exports = __webpack_public_path__ + "static/media/pin-selected.0933b23f.svg";